// Kartu Dashboard mengikuti filter Jenjang. Angka per jenjang dihitung SERVER (`per_jenjang` dari
// GET /dashboard/summary, sumber sama dgn kartu "Semua"); arsip bulanan tidak membawa field itu -> kartu
// tetap menampilkan angka semua jenjang dgn keterangan.

export const JENJANG_DASHBOARD = ["Sp1", "Sp2", "Koas"];
export const SEMUA_JENJANG = "all";

const KUNCI_AKTIF = { Sp1: "sp1_aktif", Sp2: "sp2_aktif", Koas: "koas_aktif" };
const angka = (v) => Number(v || 0).toLocaleString("id-ID");

// Angka kartu utk jenjang terpilih. `tersaring` = angka benar-benar sudah per jenjang itu.
export function angkaKartu(summary, jenjang) {
    const semua = {
        aktif: summary.aktif, terdaftar: summary.terdaftar, stase: summary.stase,
        sp1_aktif: summary.sp1_aktif, sp2_aktif: summary.sp2_aktif, koas_aktif: summary.koas_aktif,
    };
    const pj = summary.per_jenjang?.[jenjang];
    if (jenjang === SEMUA_JENJANG || !pj) return { ...semua, tersaring: false };
    const perKartu = Object.fromEntries(JENJANG_DASHBOARD.map((j) => [KUNCI_AKTIF[j], j === jenjang ? pj.aktif : 0]));
    return { ...semua, ...perKartu, aktif: pj.aktif, terdaftar: pj.terdaftar, stase: pj.stase, tersaring: true };
}

// Baris kecil keterangan lingkup di kartu. `jenjangTerkunci`: jenjang akun Admin Prodi/Koas (tanpa filter).
export function teksLingkup({ jenjang, tersaring, terkunci, jenjangTerkunci }) {
    if (terkunci) return jenjangTerkunci ? `${jenjangTerkunci}, status Aktif` : "Status Aktif";
    if (tersaring) return `${jenjang}, status Aktif`;
    const dasar = "Semua jenjang (Sp1 + Sp2 + Koas), status Aktif";
    return jenjang === SEMUA_JENJANG ? dasar : `${dasar} — arsip ini belum memuat rincian per jenjang`;
}

// Kartu Sp1/Sp2/Koas Aktif: jenjang kartu itu sendiri, atau keterangan "di luar filter".
export function lingkupKartuJenjang(jenjangKartu, jenjang, tersaring) {
    if (tersaring && jenjangKartu !== jenjang) return `Di luar filter Jenjang ${jenjang}`;
    return `${jenjangKartu}, status Aktif`;
}

// ["Sp1 1.458 / 561", "Sp2 302 / 80", "Koas 248 / 0"] (RSCM / Luar), hanya bila per_jenjang tersedia.
export function rincianStasePerJenjang(summary) {
    if (!summary.per_jenjang) return null;
    return JENJANG_DASHBOARD.map((j) => {
        const st = summary.per_jenjang[j]?.stase || {};
        return `${j} ${angka(st.rscm)} / ${angka(st.luar)}`;
    });
}

// Parameter unduhan Dashboard: jenjang hanya dikirim bila dipilih (Semua = tanpa parameter, seperti sebelumnya).
export function paramUnduhDashboard(jenjang, terkunci) {
    return terkunci || jenjang === SEMUA_JENJANG ? { halaman: "dashboard" } : { halaman: "dashboard", jenjang };
}
